<template>
  <v-dialog v-model="opened" max-width="310" persistent light>
    <v-card>
      <v-card-title class="headline">
        Unsaved changes
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">Modifications non enregistrées. Êtes-vous sûr de vouloir continuer sans enregistrer les modifications ?</v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn color="error" small @click="agree">
          Continuer
        </v-btn>

        <v-btn color="info" small @click="cancel">
          Annuler
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { EventBus } from '@/utils/pwa';

const opened = ref(false);
const methods = ref(null);

const open = methodsArg => {
  opened.value = true;
  methods.value = methodsArg;
};

const agree = () => {
  if (methods.value.acceptMethod) {
    methods.value.acceptMethod();
  }
  opened.value = false;
};

const cancel = () => {
  if (methods.value.abortMethod) {
    methods.value.abortMethod();
  }
  opened.value = false;
};

onMounted(() => {
  EventBus.$on('openUnsavedChangesAlert', open);
});

onBeforeUnmount(() => {
  EventBus.$off('openUnsavedChangesAlert');
});

</script>